import { CompactTable } from '@/components/Table'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { MEAL_PARTS } from '../constants'
import { MealPart } from '@/api/types'

type Props = {
  onSelectionChange: (value: string) => void
}

export default function MealPartSelector({ onSelectionChange }: Props) {
  const { t } = useTranslation()
  return (
    <CompactTable
      aria-label="Meal parts"
      selectionMode="single"
      onSelectionChange={(items) => onSelectionChange([...items][0] as MealPart)}
      rowId="name"
      sorting
      search={{
        columns: ['label'],
      }}
      columns={[
        {
          key: 'label',
          label: t('ingredient.name'),
        },
      ]}
      rows={MEAL_PARTS.map((name) => ({ name, label: t(`mealParts.${name}` as any) }))}
    />
  )
}
